module.exports = __webpack_public_path__ + "img/partner-new-icon3.3493eae1.svg";